import script from "./reviewFailModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./reviewFailModal.vue?vue&type=script&lang=ts&setup=true"

import "./reviewFailModal.vue?vue&type=style&index=0&id=1d2e5cd7&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2e5cd7"]])

export default __exports__